import i18n from 'live/services/i18n'
import { isEqual } from 'lodash'
import React, { useState } from 'react'
import { Table } from 'react-bootstrap'
import styled from 'styled-components'
import { ParameterSelectedProps } from './ParametersEditionButton'

interface ParametersEditionListProps {
    dark: any
    toggleModal: Function
    dashboardParameters: ParameterSelectedProps[]
    save: Function
}

const ParametersList = ({
    dark,
    toggleModal,
    dashboardParameters,
    save
}: ParametersEditionListProps) => {
    const [newParameters, setNewParameters] = useState<ParameterSelectedProps[]>(dashboardParameters)

    function updateParameter(pos: number) {
        const updatedParam = newParameters.map((e, i) => ({ ...e, selected: (i === pos ? !e.selected : e.selected) }))
        setNewParameters(updatedParam)
    }

    function reset() {
        setNewParameters(dashboardParameters)
        toggleModal()
    }

    const unsavedChanges = !isEqual(newParameters, dashboardParameters)
    const saveDisabled = !unsavedChanges

    return (
        <StyledParametersEditionList
            dark={dark}
        >
            <Table size="sm" responsive="xl">
                <thead>
                    <tr>
                        <th className="td-selected">Selected</th>
                        <th className="td-key">Key</th>
                        <th className="td-name">Name</th>
                        <th className="td-value">Default</th>
                        <th className="td-uom">uom</th>
                        <th className="td-redoQuery">RedoQuery</th>
                        <th className="td-group">Group</th>
                    </tr>
                </thead>
                <tbody>
                    {newParameters.map(({ key, name, value, uom, redoQuery, group, selected }, i) => {
                        return (
                            <tr key={i}>
                                <td className="td-selected">
                                    <input
                                        type="checkbox"
                                        checked={selected}
                                        onChange={e => updateParameter(i)}
                                    />
                                </td>
                                <td className="td-key">{key}</td>
                                <td className='td-name'>{name}</td>
                                <td className="td-value">{value}</td>
                                <td className="td-uom">{uom}</td>
                                <td>{redoQuery.toString()}</td>
                                <td>{group}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>

            <MainAEditionActions dark={dark}>
                <div className="buttons">
                    <button className="btn btn-primary" onClick={() => { save(newParameters) }} disabled={saveDisabled}>Save</button>
                    <Cancel onClick={reset}>Cancel</Cancel>
                    {unsavedChanges ? (<div className='unsaved-changes'>{i18n('* You have unsaved changes')}</div>) : null}
                </div>
            </MainAEditionActions>
        </StyledParametersEditionList>
    )
}


const StyledParametersEditionList = styled.div`
    position: absolute;
    top: 26px;
    left: -300px;
    border-radius: 0px;
    background-color: var(--gray-0);
    margin-top: 2px;
    border: 1px solid rgb(200, 204, 212);
    box-shadow: rgba(96, 105, 128, 0.25) 0px 0px 5px 0px;
    z-index: 100;
    cursor: auto !important;

    table {
        display: flex;
        flex-direction: column;

        td {
            min-width: 100px;
            padding: 10px !important;
            color: var(--text-color) !important;
            font-family: var(--font-regular) !important;
        }

        th {
            min-width: 100px;
            padding: 16px 10px !important;
            color: var(--text-color) !important;
            font-family: var(--font-bold) !important;
        }

        .td-selected {
            min-width: 75px !important;
            text-align: center;

            input {
                border: solid 1px var(--gray) !important;
            }
        }

        .td-name {
            min-width: 250px !important;
        }

        .td-key {
            min-width: 150px !important;
        }

        .td-value {
            min-width: 150px !important;
        }
    }

    tbody {
        display: block;
        overflow-y: scroll;
        max-height: 600px;
    }
`

const Cancel = styled.div`
    background: none !important;
    border: none;
    padding: 0px !important;
    color: var(--color-link) !important;
    text-decoration: underline;
    cursor: pointer !important;
    margin-left: 16px !important;
`

const MainAEditionActions = styled.div`
    border-top: 1px solid ${props => (props.dark ? '#172033' : '#c8ccd4')};
    padding: 10px;
    width: 100%;
    button {
        height: auto !important;
        margin: 0px !important;
    }

    .buttons {
        display: flex;
        align-items: center;
    }

    .unsaved-changes {
        right: 30px;
        position: absolute;
        color: var(--brand-warning);
    }
`

export default ParametersList
